<script setup>
// import { ref } from 'vue';
import BatchDetailTable from "./Tables/BatchDetailTable.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import PrintBatchLabelModal from "./components/PrintBatchLabel.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Edit Batch Profile - <i>#{{ batchno }}</i></h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Block</label>
                            <input class="form-control" v-model="model.batch.block" id="input_block" type="text" placeholder="Block..." disabled />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Product</label>
                            <select class="form-control" v-model="model.batch.product" disabled>
                                <option value="SW">Sawit</option>
                                <option value="GT">Getah</option>
                                <option value="DR">Durian</option>
                                <option value="KK">Koko</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Clone</label>
                            <select class="form-control" v-model="model.batch.clone" disabled >
                                <option value="1" v-if="model.batch.product === 'SW'">FGV</option>
                                <option value="2" v-if="model.batch.product === 'SW'">AAR</option>
                                <option value="3" v-if="model.batch.product === 'SW'">GH 500</option>
                                <option value="4" v-if="model.batch.product === 'SW'">KK</option>
                                <option value="5" v-if="model.batch.product === 'SW'">UP</option>
                                <option value="9" v-if="model.batch.product === 'SW'">IOI</option>
                                <option value="6" v-if="model.batch.product === 'GT'" >PB 350</option>
                                <option value="7" v-if="model.batch.product === 'DR'">Musang King</option>
                                <option value="8" v-if="model.batch.product === 'DR'">Duri Hitam</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Date</label>
                            <input class="form-control" v-model="model.batch.date" id="input_date" type="date" disabled />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Quantity</label>
                            <input class="form-control" v-model="model.batch.quantity" id="input_quantity" type="text" placeholder="quantity..." />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Status</label>
                            <select class="form-control" v-model="model.batch.status">
                                <option value="0">Open</option>
                                <option value="1">Closed</option>
                                <option value="2">Booked</option>
                                <option value="3">Cancel</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.batch.remark"  placeholder="Remark...." />
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="updateBatch" style="float: right;" id="btn_update">Update</button>
                            <button class="btn btn-primary me-3" @click="showPopupPrintLabel" style="float: right;" id="btn_print">Print</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mt-4 row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Insert Detail</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Batch No:</label>
                            <input class="form-control" v-model="model.batchdetail.batchno" id="input_block" type="text" placeholder="Block..." disabled />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Date</label>
                            <input class="form-control" v-model="model.batchdetail.date" id="input_date" type="date" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Type</label>
                            <select class="form-control" v-model="model.batchdetail.type" >
                                <!-- <option value="1">Baja</option>
                                <option value="2">Racun</option>
                                <option value="3">Mesin Rumput</option>
                                <option value="4">Cabut Rumput</option>
                                <option value="5">Other</option> -->
                                <option v-for="(item,index) in model.batchdetailstatuslist" :key="index" :value="item.batchdetailstatusid" v-show="item.batchdetailstatusid != 5 && item.batchdetailstatusid != 6">
                                    {{ item.statusdesc }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-5">
                            <label for="example-text-input" class="form-control-label text-danger">Detail</label>
                            <input class="form-control" v-model="model.batchdetail.detail" id="input_detail" type="text" placeholder="Details..." />
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addBatchDetail" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mt-4 row">
        <div class="col-12">
            <BatchDetailTable :key="componentKey" />
        </div>
    </div>
<div class="mt-4 row">
    <PrintBatchLabelModal :id="$route.params.id" :key="componentKey2">
    </PrintBatchLabelModal>
</div>
</div>
</template>


<script>
import axios from 'axios';
import { Modal } from 'bootstrap';

export default {
  name:'batchCreate',
  components:{
    PrintBatchLabelModal,
  },
  data(){
    return {
        myModal:'',
        batchno:'',
        componentKey: 0,
        componentKey2: 0,
    //   errorList: '',
      model:{
        batchdetailstatuslist:[],
        batchdetail:{
            type:"1",
            batchno:'',
            detail:'',
            date: new Date().toISOString().slice(0,10)
        },
        batch:{
            batchno: '',
            clone:"1",
            product:'SW',
            block:'',
            date: new Date().toISOString().slice(0,10),
            quantity:'',
            remark:'',
            status:'0'
        }
      },
    }
  },
  mounted(){
    this.model.batchdetail.batchno = this.$route.params.id;
    this.batchno = this.$route.params.id;
    this.loadBatchProfile();
    this.loadBatchDetailStatus();
    this.myModal = new Modal(document.getElementById('PrintLabelModal'));
  },
  methods: {
    currentDate() {
      const firstDayMonth = new Date();
      const date = `${firstDayMonth.getMonth()+1}/02/${firstDayMonth.getFullYear()}`;
      return date;
    },
    loadBatchProfile(){
        // console.log(this.model.stockProfile);
        // var mythis = this;
        axios.get('nursery/listBatchProfile/'+this.batchno)
            .then(res => {
                this.model.batch = {
                    clone: res.data.batchProfile[0].clone,
                    product: res.data.batchProfile[0].product,
                    block: res.data.batchProfile[0].block,
                    date: res.data.batchProfile[0].date,
                    quantity: res.data.batchProfile[0].quantity,
                    remark: res.data.batchProfile[0].remark,
                    status: res.data.batchProfile[0].status
                };
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Vehicle No and type is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    addBatchDetail(){
        // console.log(this.model.stockProfile);
        // var mythis = this;
        axios.post('nursery/addBatchDetail',this.model.batchdetail)
            .then(res => {
                alert(res.data.message);
                this.model.batchdetail = {
                    type:"1",
                    batchno:this.$route.params.id,
                    detail:'',
                    date: new Date().toISOString().slice(0,10)
                };
                this.componentKey += 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Vehicle No and type is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    updateBatch(){
        this.model.batch.batchno = this.$route.params.id;
        // var mythis = this;
        axios.post('nursery/updateBatchProfile',this.model.batch)
            .then(res => {
                this.componentKey2 += 1;
                this.componentKey += 1;
                alert(res.data.message);
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Status and Quantity is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    getSewaProfile(){
        // var mythis = this;
        axios.get('sewa/listAllSewaProfile')
            .then(res => {
                this.model.sewaProfile = res.data.sewaProfile;
                this.model.sewa.sewaprofileid = res.data.sewaProfile[0].id;
                this.model.sewa.amount = res.data.sewaProfile[0].amount;
                // console.log(res.data.sewaProfile[0]);
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    showPopupPrintLabel(){
        this.myModal.show();
    },
    loadBatchDetailStatus(){
        axios.get('nursery/listAllBatchDetailStatus')
            .then(res => {
                this.model.batchdetailstatuslist = res.data.batchdetailstatus;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        console.log(error.response.message);
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
  },
}
</script>
